<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Profil Einstellungen"}}</h4>
	</div>
</div>
<div class="row">
	<div class="col-sm-12">
		<div class="card-box clearfix">
			<div class="col-xs-12 col-md-7">
				<dl class="dl-horizontal m-b-0 m-t-15">
					{{#each setting}}
						<div class="m-b-15">
							<div class="row">
								<div class="col-xs-7">
									<dt>{{key}}</dt>
									<dd id="ct-{{id}}">
										{{value}}
									</dd>
								</div>
								<div class="col-xs-5">
									<button type="button" id="js-{{id}}" class="btn btn-white pull-right" data-target="#profileModal" data-toggle="modal">
										<i class="glyphicon glyphicon-pencil"></i>
									</button>
									{{#COMPARE id '==' 'phone'}}
									{{#if hasPhoneNumber}}
									<button type="button" id="js-deletePhoneNumber" class="btn btn-white pull-right m-r-10" data-target="#profileModal" data-toggle="modal">
										<i class="glyphicon glyphicon-trash"></i>
									</button>
									{{/if}}
									{{/COMPARE}}
									{{#COMPARE id '==' 'password'}}
									<button type="button" id="js-mfaConfiguration" class="btn btn-white pull-right m-r-10">
										{{TR "2FA"}}&nbsp;<i class="fa fa-{{#if hasMFAenabled}}check text-success{{else}}times text-danger{{/if}} m-l-5"></i>
									</button>
									{{/COMPARE}}
								</div>
							</div>
						</div>
					{{/each}}
				</dl>
			</div>
			<div class="col-xs-12 col-md-5 m-t-15 m-b-15">
				<button id="js-messages" type="button" class="btn btn-white js-messages pull-right" data-target="#profileModal" data-toggle="modal">
					<i class="glyphicon glyphicon-pencil m-r-10"></i>{{TR "Benachrichtigungen"}}
				</button>
			</div>
		</div>
	</div>
</div>


{{#if devices}}
<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Geräteübersicht"}}</h4>
	</div>
</div>
<div class="row">
	{{#each devices}}
	<div class="col-md-6 col-lg-4">
		<div class="widget-bg-color-icon card-box">
			{{#IF_AVAILABLE 'status'}}
			<a href='#search?filter=%7B"category"%3A%5B"{{category}}"%5D%7D' >
				<div class="bg-icon bg-icon-{{color}} pull-left">
					<i class="{{icon}} text-{{color}}"></i>
				</div>
			</a>
			{{else}}
				<div class="bg-icon bg-icon-success pull-left">
					<i class="{{icon}} text-success"></i>
				</div>
			{{/IF_AVAILABLE}}
			<div class="text-right">
				<h3 class="text-dark"><b id="js-{{category}}" class="counter">{{name}}</b></h3>
				<h3 class="text-muted"><b>{{count}}</b></h3>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
	{{/each}}
</div>
{{/if}}
